import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SubHeader from './SubHeader';
import OrdersTable from './OrdersTable';
import './OrdersManagerDashboard.css';

@inject('commonStore', 'translationsStore', 'filterStore', 'ordersStore')
@observer
export default class OrdersManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    const { ordersStore } = this.props;
    ordersStore.load();
  }

  componentDidMount = () => {};

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  render() {
    const { ordersStore } = this.props;
    return (
      <div className={`OrdersManagerDashboard ${this.props.commonStore.loading ? 'loading' : ''}`}>
        <SubHeader />
        {this.props.commonStore.loading === false && <OrdersTable orders={ordersStore.filtered} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/OrdersManagerDashboard.js